<template>
  <div class="container2">
    <!-- 展商信息 -->
    <div class="row1">
      <div class="exhibitor">
        <div class="title">
          <h3>{{ $t('homepage.exhibitor') }}</h3>
          <button @click="editExhi">{{ $t('homepage.editexhibitor') }}</button>
        </div>
        <div class="content">
          <div class="img">
            <img v-if="company.comCover" :src="`${company.comCover.includes('https')?'':imgbaseUrl}${company.comCover}`" alt="" />
            <img v-else alt="" src="../../static/logo_default.png" />
          </div>
          <div class="detail">
            <p>{{ company.companyNameC }}</p>
            <div>
              <span
                >{{ $t('homepage.pavilion') }}：<i style="color: #333333">{{ addcomma(boothList.boothName) }}</i></span
              >
              <span
                >{{ $t('homepage.positionNumber') }}：<i style="color: #333333">{{ addcomma(boothList.boothNum) }}</i></span
              >
            </div>

            <div>
              <span
                >{{ $t('homepage.boothType') }}：{{ boothList.bootTypeName[0] }}
                <el-popover v-show="show.showmore" :visible-arrow="false" placement="bottom-start" popper-class="popover_showmore" trigger="hover" width="425">
                  <div class="etc">
                    <table style="width: 100%">
                      <thead>
                        <tr>
                          <th>{{ $t('homepage.pavilion') }}</th>
                          <th>{{ $t('homepage.positionNumber') }}</th>
                          <th>{{ $t('homepage.boothType') }}</th>
                          <th>{{ $t('homepage.boothArea') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in company.hzBoothList">
                          <td>{{ item.boothName }}</td>
                          <td>{{ item.boothNum }}</td>
                          <td>{{ item.bootTypeName }}</td>
                          <td>{{ item.boothArea }}m²</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <el-button slot="reference" circle icon="el-icon-more" size="mini" style="padding: 1px" type="primary"></el-button>
                </el-popover>
              </span>
              <span class="lastSpan" v-show="boothList.boothArea.length !== 0">{{ $t('homepage.boothArea') }}:{{ addcomma(boothList.boothArea) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="infor">
        <h3>{{ $t('homepage.statistics') }}</h3>
        <div class="shujv">
          <div class="box2">
            {{ $t('homepage.completeness') }}
            <h2>{{ dataStatistics.informationCompleteness }}</h2>
          </div>
          <div class="box2">
            {{ $t('homepage.productnum') }}
            <h2>{{ dataStatistics.numberOfProducts }}</h2>
          </div>

          <div class="box2">
            {{ $t('homepage.activenum') }}
            <h2>{{ dataStatistics.scene }}</h2>
          </div>
          <div class="box2">
            {{ $t('homepage.livenum') }}
            <h2>{{ dataStatistics.liveBroadcast }}</h2>
          </div>
          <div class="box2">
            {{ $t('homepage.audiencenum') }}
            <h2>{{ dataStatistics.appointmentAudience }}</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品中心 -->
    <div class="row2">
      <div class="title">
        <h3>{{ $t('homepage.product') }}</h3>
        <div v-show="show.prodect" class="button">
          <button class="all" @click="productList1">{{ $t('homepage.viewall') }}</button>
          <button class="add" @click="addproduct">{{ $t('homepage.addproduct') }}</button>
        </div>
      </div>
      <div class="product">
        <div v-for="(item, index) in prodect.list" v-show="show.prodect" :key="index" @click="productEdit(item.id)" class="procuct_box">
          <div class="img1">
            <img :src="`${item.exhibitsCoverImg.includes('https')?'':imgbaseUrl}${item.exhibitsCoverImg}`" alt="" />
          </div>
          <h4>{{ item.exhibitsName }}</h4>
          <p>{{ item.column17 }}</p>
        </div>

        <!--显示空数据-->
        <div v-show="!show.prodect" class="nodata">
          <div>
            <img alt="" src="../../static/nodata.png" />
          </div>
          <div class="tip">
            <p>{{ $t('homepage.nonproduct') }}</p>
          </div>
          <div class="button">
            <button class="add" @click="addproduct">{{ $t('homepage.addproduct') }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 展商新闻 -->
    <div class="row3 row2">
      <div class="news">
        <div class="title">
          <h3>{{ $t('homepage.news') }}</h3>
          <div v-show="show.news" class="button">
            <button class="all" @click="newsList">{{ $t('homepage.viewall') }}</button>
            <button class="add" @click="addNews">{{ $t('homepage.addnews') }}</button>
          </div>
        </div>
        <div class="news_content">
          <div v-for="(news, index) in news.list" v-show="show.news" :key="index" class="news_box">
            <p>
              {{ news.newsTitle }}
            </p>
            <p class="time">{{ news.updateDate }}</p>
          </div>

          <!--显示空数据-->
          <div v-show="!show.news" class="nodata">
            <div>
              <img alt="" src="../../static/nodata.png" />
            </div>
            <div class="tip">
              <p>{{ $t('homepage.nonnews') }}</p>
            </div>
            <div class="button">
              <button class="add" @click="addNews()">{{ $t('homepage.addnews') }}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="active">
        <div class="title">
          <h3>{{ $t('homepage.active') }}</h3>
          <div class="button" v-show="show.active">
            <button class="all" @click="activelist">{{ $t('homepage.viewall') }}</button>
            <button class="add" @click="add_active">{{ $t('homepage.addactive') }}</button>
          </div>
        </div>
        <div class="active_box">
          <div v-for="(item, index) in active.list" :key="index" class="active_content" v-show="show.active">
            <div class="img">
              <img :src="imgbaseUrl + item.column15" alt="" />
            </div>
            <p>{{ item.actTitle }}</p>
            <p>
              <img alt="" src="../../static/ico_time.png" /><span>{{ item.startTime }}</span>
            </p>
            <p>
              <img alt="" src="../../static/ico_address.png" /><span>{{ item.address }}</span>
            </p>
          </div>

          <!--显示空数据-->
          <div v-show="!show.active" class="nodata">
            <div>
              <img alt="" src="../../static/nodata.png" />
            </div>
            <div class="tip">
              <p>{{ $t('homepage.nonactive') }}</p>
            </div>
            <div class="button">
              <button class="add" @click="add_active">{{ $t('homepage.addactive') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 展商直播 -->
    <div class="row4 row2">
      <div class="live">
        <div class="title">
          <h3>{{ $t('homepage.live') }}</h3>
          <div v-show="show.live" class="button">
            <button class="all" @click="livelist">{{ $t('homepage.viewall') }}</button>
            <button class="add" @click="add_live">{{ $t('homepage.addlive') }}</button>
          </div>
        </div>
        <div class="active_box">
          <div v-for="(item, index) in live.list" v-show="show.live" :key="index" class="active_content">
            <div class="img">
              <img :src="imgbaseUrl + item.coverPhoto" alt="" />
            </div>
            <p>{{ item.liveCn }}</p>
            <!--            <p>-->
            <!--              <img src="../../static/ico_time.png" alt="" /><span>{{-->
            <!--                item.live_day-->
            <!--              }}</span>-->
            <!--            </p>-->
            <p>
              <span><img alt="" src="../../static/ico_time.png" />{{ item.startDate }}</span>
            </p>
          </div>

          <!--显示空数据-->
          <div v-show="!show.live" class="nodata">
            <div>
              <img alt="" src="../../static/nodata.png" />
            </div>
            <div class="tip">
              <p>{{ $t('homepage.nonlive') }}</p>
            </div>
            <div class="button">
              <button class="add" @click="add_live">{{ $t('homepage.addlive') }}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- 我的霞浦县哦 -->
      <div class="mine">
        <div class="title">
          <h3>{{ $t('homepage.message') }}</h3>
          <!-- <div class="button">
            <button class="all" @click="view_all">{{ $t('homepage.viewall') }}</button>
          </div> -->
        </div>
        <div v-for="(item, index) in quiz" :key="index" class="xinxi">
          <div class="name">
            <span class="left" :title="item.name">{{ item.name }}</span>
            <span class="right">{{ item.time.slice(0, 10) }}</span>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
        <div v-show="!show.consult" class="nodata">
          <div>
            <img alt="" src="../../static/nodata.png" />
          </div>
          <div class="tip">
            <p>{{ $t('homepage.nonmessage') }}</p>
          </div>
          <!-- <div class="button">
            <button class="add" @click="consultzs()">{{ $t('homepage.addmessage') }}</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExhition } from '../../../api/exhibitor';
import { productList } from '../../../api/productCenter';
import { getnewsList } from '../../../api/newCenter';
import { getliveList } from '../../../api/liveCenter';
import { forMat, backExhibitionList } from '../../../utils/common';
import { getStatistics } from '../../../api/homePage.js';
import { getLists } from '../../../api/active';
import { getMyMessageLists } from '../../../api/message.js';

export default {
  data() {
    return {
      exhibitionUrl: backExhibitionList(),
      dataStatistics: {},
      imgbaseUrl: '',
      //是否显示
      show: {
        showmore: false, //展商多展位时弹出框按钮
        prodect: false,
        news: false,
        live: false,
        message: false,
        active: false,
        consult: false,
      },
      //展商信息
      company: [],
      //展位信息
      boothList: {
        boothName: [], //展馆
        boothNum: [], //展位号
        bootTypeName: [], //展位类型
        boothArea: [], //展位面积
      },

      //产品数据
      prodect: [],

      //新闻数据
      news: [],
      //展商活动
      active: [
        // {
        //   imgurl: require('@/static/tupian.png'),
        //   time: '2023年06月16日 14：00',
        //   address: 'E2-202',
        // },
        // {
        //   imgurl: require('@/static/tupian.png'),
        //   time: '2023年06月16日 14：00',
        //   address: 'E2-202',
        // },
      ],
      //展商直播
      live: [],
      //个人信息提问
      quiz: [],
    };
  },

  components: {},

  created() {
    this.init();
    this.imgbaseUrl = forMat(); //引入公共图片路径
    this.getStatisticsData();
  },

  activated() {
    this.init();
    this.imgbaseUrl = forMat();
  },

  methods: {
    consultzs() {
      // 跳转至线上展会列表
      window.location.href = this.exhibitionUrl;
    },
    async getStatisticsData() {
      // 获取数据统计
      try {
        const { data } = await getStatistics();
        this.dataStatistics = data.data;
      } catch (err) {
        console.log(err);
      }
    },
    //展商信息
    async getExhition() {
      try {
        let { data } = await getExhition();
        this.company = data.data;
        this.boothList = {
          boothName: [], //展馆
          boothNum: [], //展位号
          bootTypeName: [], //展位类型
          boothArea: [], //展位面积
        };
        //如果展位信息为无
        if (this.company.hzBoothList.length === 0 || typeof this.company.hzBoothList === 'undefined') {
          return (this.boothList = {
            boothName: ['无'], //展馆
            boothNum: ['无'], //展位号
            bootTypeName: ['无'], //展位类型
            boothArea: [], //展位面积 不显示
          });
        }
        // 如果有展位信息
        if (this.company.hzBoothList.length > 0) {
          this.company.hzBoothList.forEach((item, index) => {
            this.boothList.boothName.push(item.boothName);
            this.boothList.boothNum.push(item.boothNum);
            this.boothList.bootTypeName.push(item.bootTypeName);
            this.boothList.boothArea.push(item.boothArea + 'm²');
          });
          //多展位时显示弹框
          if (this.company.hzBoothList.length > 1) {
            return (this.show.showmore = true);
          } else {
            return (this.show.showmore = false);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    addcomma(arr) {
      return arr.join('、');
    },

    //产品信息
    async productList() {
      try {
        let { data } = await productList({ page: 1, size: 5 });
        this.prodect = data.data;
        if (this.prodect.count > 0) {
          this.show.prodect = true;
        }
      } catch (err) {
        console.log(err);
      }
    },

    //新闻信息
    async getnewsList() {
      try {
        let { data } = await getnewsList({ pageNo: 1, pageSize: 5, auditFlag: 0 });
        this.news = data.data;
        if (this.news.count > 0) {
          this.show.news = true;
          //截取时间格式
          this.news.list.forEach((item, index) => {
            // let newdate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.updateDate);
            let newdate = item.updateDate.substr(0, 10);
            this.news.list[index].updateDate = newdate;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    //直播信息
    async getliveList() {
      try {
        let { data } = await getliveList({ pageNo: 1, pageSize: 3, auditFlag: 0 });
        this.live = data.data;
        if (this.live.count > 0) {
          this.show.live = true;
          this.live.list.forEach((item, index) => {
            let date = new Date(item.startDate);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            let h = date.getHours();
            let mm = date.getMinutes();
            let newdate = y + '年' + this.add0(m) + '月' + this.add0(d) + '日 ' + this.add0(h) + ':' + this.add0(mm);
            this.live.list[index].startDate = newdate;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    //获取活动列表
    async getactiveList() {
      try {
        let { data } = await getLists({ pageNo: 1, pageSize: 2, auditFlag: 0 });
        this.active = data.data;
        if (this.active.count > 0) {
          this.show.active = true;
          this.active.list.forEach((item, index) => {
            let date = new Date(item.startTime);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            let h = date.getHours();
            let mm = date.getMinutes();
            let newdate = y + '年' + this.add0(m) + '月' + this.add0(d) + '日 ' + this.add0(h) + ':' + this.add0(mm);
            this.active.list[index].startTime = newdate;
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    // 获取消息列表
    async getConsultLists() {
      try {
        const { data } = await getMyMessageLists();
        if (data.code === 200) {
          if (data.data.length > 0) {
            this.show.consult = true;
            this.quiz = data.data.slice(0,3);
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    add0(m) {
      return m < 10 ? '0' + m : m;
    },

    init() {
      this.show = {
        showmore: false, //展商多展位时弹出框按钮
        prodect: false,
        news: false,
        live: false,
        message: false,
        active: false,
        consult: false,
      };
      this.getExhition();
      this.productList();
      this.getnewsList();
      this.getliveList();
      this.getactiveList();
      this.getConsultLists();
    },

    //展商编辑页面信息
    editExhi() {
      this.$router.push('/backIndex/exhiIndex');
    },

    //新增直播页面
    add_live() {
      this.$router.push('/backIndex/addExhiLive');
    },

    //新增活动
    add_active() {
      this.$router.push('/backIndex/add_active');
    },

    //新增新闻
    addNews() {
      this.$router.push('/backIndex/add_news');
    },

    //查看新闻列表
    newsList() {
      this.$router.push('/backIndex/exhi_news');
    },

    //查看产品列表
    productList1() {
      this.$router.push('/backIndex/productIndex');
    },

    //跳转到展商活动
    livelist() {
      this.$router.push('/backIndex/exhiLive');
    },

    //跳转到展商活动
    activelist() {
      this.$router.push('/backIndex/active_list');
    },

    //新增产品
    addproduct() {
      this.$router.push('/backIndex/addproduct');
    },

    // 我的消息  查看全部
    view_all() {
      this.$router.push('/backIndex/mineMessage');
    },

    //编辑产品
    productEdit(id) {
      this.$router.push({
        name: 'editproduct',
        query: {
          id,
        },
      });
    },
  },
  beforeDestroy(){
    // localStorage.removeItem('lang')

  }
};
</script>

<style lang="scss" scoped>
.container2 {
  margin-right: 9px;
  background: #f0f2f5;

  // width: 1418px;
  //  border: 1px solid red;

  .row1 {
    display: flex;
    height: 217px;

    .exhibitor {
      width: 50%;
      min-width: 662px;
      margin-right: 26px;
      box-sizing: border-box;
      padding: 17px 26px 26px 0;
      background: white;
      // border: 1px solid red;
      .title {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0 9px 26px;
        border-bottom: 1px solid #e9e9e9;

        button {
          width: 76px;
          height: 28px;
          border: none;
          background: #006fb8;
          color: white;
          border-radius: 4px;
        }
      }

      .content {
        display: flex;
        box-sizing: border-box;
        padding: 17px 26px 25px;

        .img {
          width: 192px;
          height: 108px;
          text-align: center;
          margin-right: 30px;

          img {
            max-width: 192px;
            max-height: 108px;
          }
        }

        .detail {
          // border: 1px solid red;
          width: 66%;
          p:first-child {
            margin-bottom: 25px;
          }
          div {
            line-height: 18px;
            display: flex;
          }

          div:last-child {
            margin-top: 10px;
            .lastSpan {
              width: 200px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          span {
            display: inline-block;
            width: 50%;
            font-size: 14px;

            white-space: nowrap;

            i {
              font-style: normal;
              font-size: 17px;
              margin-top: 5px;
              display: inline-block;
              width: 72%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }

    .infor {
      width: 50%;
      min-width: 514px;
      box-sizing: border-box;
      background: white;

      h3 {
        border-bottom: 1px solid #e9e9e9;
        box-sizing: border-box;
        padding: 18px 0 11px 26px;
      }

      .shujv {
        // border: 1px solid red;
        display: flex;
        height: 68px;
        // width: 657px;
        margin: 44px 52px 34px 37px;
        justify-content: space-around;

        .box2 {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 17px;

          h2 {
            margin-top: 17px;
            font-size: 26px;
            font-family: HelveticaNeue-Medium, HelveticaNeue;
            font-weight: 500;
            color: #333333;
            line-height: 33px;
          }
        }
      }
    }
  }

  .row2 {
    width: 100%;
    min-width: 1127px;
    box-sizing: border-box;
    padding: 0px 0 26px 0;
    margin-top: 26px;
    background: white;

    .title {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 15px 16px 9px 26px;
      border-bottom: 1px solid #e9e9e9;

      .button {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;

        .all {
          width: 76px;
          height: 28px;
          background: white;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
        }

        .add {
          width: 84px;
          height: 28px;
          background: #006fb8;
          border: none;
          margin-left: 9px;
          color: white;
          border-radius: 4px;
        }
      }
    }

    .product {
      display: flex;
      margin-left: 26px;

      .procuct_box {
        margin-right: 26px;
        margin-top: 27px;
        width: 25%;

        .img1 {
          width: 100%;
          height: 187px;

          img {
            max-height: 100%;
            width: auto;
            max-width: 100%;
          }
        }

        h4 {
          margin-top: 17px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 19px;
        }

        p {
          margin-top: 9px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
        }
      }
    }
  }

  .row3 {
    display: flex;
    background: #f0f2f5;
    // border: 1px solid red;
    .news {
      width: 63%;
      min-width: 573px;
      height: 398px;
      background: white;

      .news_content {
        box-sizing: border-box;
        padding-right: 15px;
      }

      .news_box {
        display: flex;
        height: 45px;
        margin-left: 26px;
        line-height: 45px;
        justify-content: space-between;
        border-bottom: 1px solid #e9e9e9;

        p:first-child {
          width: 80%;
          font-size: 14px;
          overflow: hidden;
          font-weight: 500;
          color: #333333;
          font-family: PingFangSC-Medium, PingFang SC;
          margin-right: 56px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        p:last-child {
          font-size: 12px;
          font-weight: 400;
          width: 14%;
          color: #999999;
        }

        .time {
          margin-right: 15px;
        }
      }
    }

    .active {
      width: 590px;
      height: 398px;
      margin-left: 26px;
      background: white;

      .active_box {
        //margin: 17px 0 0 26px;
        margin: 0 26px;
        display: flex;

        .active_content {
          margin-top: 17px;
          width: 45%;
          margin-right: 5%;

          .img {
            height: 192px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              max-width: 100%;
              max-height: 100%;
            }
          }

          p {
            width: 239px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 9px;

            span {
              //color: #fdd000;
              color: #666666;
            }

            img {
              vertical-align: middle;
            }
          }
        }
      }
    }
  }

  .row4 {
    display: flex;
    background: #f0f2f5;
    margin-top: 0;
    padding-bottom: 0;

    .live {
      width: 65%;
      // min-width: 806px;
      background: white;

      .active_box {
        margin: 17px 0 0 26px;
        display: flex;

        .active_content {
          // width: 249px;
          // flex: 1;
          width: 30%;
          margin-right: 3%;
          // margin-right: 26px;

          .img {
            width: 100%;
            height: 192px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              max-width: 100%;
              max-height: 100%;
            }
          }

          p {
            width: 239px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 9px;

            span {
              color: #fdd000;
            }

            img {
              vertical-align: middle;
            }
          }
        }
      }
    }

    .mine {
      width: 35%;
      margin-left: 26px;
      background: white;

      .xinxi {
        padding-top: 15px;
        padding-bottom: 15px;
        box-sizing: border-box;
        margin-left: 26px;
        margin-right: 26px;
        height: 89px;
        border-bottom: 1px solid #e9e9e9;
        .name {
          display: flex;
          .left {
            width: 70%;
            // flex: 1;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            text-align: left;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }
          .right {
            width: 30%;
            // flex: 1;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 22px;
            text-align: right;
          }
        }

        .content {
          margin-top: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 14px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  //当数据为空时
  .nodata {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 10px;

    .tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      margin: 5px 0 20px;
    }

    .button .add {
      width: 84px;
      height: 32px;
      background: #006fb8;
      border: none;
      margin-left: 9px;
      color: white;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}

//展商多展位时 弹出框样式
.el-popover {
  .etc {
    table {
      border-collapse: collapse;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      padding-left: 20px;

      thead {
        background: #006fb8;

        tr {
          color: rgba(255, 255, 255, 0.85);
          height: 42px;

          th {
            font-weight: 500;
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr {
          td {
            padding: 10px 0 10px 20px;
            color: #333333;
          }
        }
      }
    }
  }
}

//::v-deep .popover_showmore {
//  padding: 0;
//}
</style>
<style>
/* el-popover与app.vue同级 别在scoped里写*/
.popover_showmore {
  padding: 0;
}
</style>
